import { createRef } from 'react';
import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import MarketingForm from './MarketingForm';

import {
  MARKETING_POPUP_IMAGE_URL
} from 'shared/utils/Constants'

import {
  getJobs
} from 'app/services/jobs';

import {
  deleteMarketing,
  uploadSignMarketingImage
} from 'app/services/marketing';

import {
  uploadFile
} from 'shared/services/FileService';

const MarketingPanel = props => {
  const {
    marketing,
    action,
    onDelete
  } = props;

  // if we're creating a moment then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  const uploadField  = createRef();

  const deleteMarketingWrapper = async () => {
    return await deleteMarketing(marketing.id)
  }

  const uploadNew = async () => {
    uploadField.current.click();
  }

  const uploadImage = async (event) => {
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];

      let resp = await uploadSignMarketingImage(marketing.id, file.type);
      await uploadFile(resp.url, file);
    }
  }

  const popupImgUrl = MARKETING_POPUP_IMAGE_URL(marketing.id);

  let cards = [
    {
      label: 'Image',
      images: [{
        id: marketing.id,
        src: popupImgUrl,
        w: 500,
        h: 500
      }],
      imageCount: 1,
    },
    {
      label: 'File',
      message: 'Marketing Popup Image',
      actions: [
        { label: 'Upload New', callback: uploadNew }
      ]
    },
    {
      label: 'Delete Marketing',
      message: 'Deleting a marketing is permanent. It will no longer be displayed across apps',
      actions: [
        { label: 'Delete Marketing', callback: deleteMarketingWrapper }
      ]
    }
  ]

  return (
    <div>
      <ResourceModalPanel cards={cards} />
      <input
          id="uploadImage"
          type="file"
          hidden
          ref={uploadField}
          onChange={(e) => {
            uploadImage(e)
          }}
      />
    </div>
  );
}

const MarketingModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    marketing
  } = props;

  const action = marketing ? 'update' : 'create';

  let title, subTitle = null;
  if (action === 'update') {
    title = marketing.name;
    subTitle = marketing.event_id;
  } else {
    title = 'New Marketing';
  }

  const onSubmit = params => onFormSubmit(action, params);
  const onDelete = () => onDestroy(marketing.id);

  return (
    <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
      <MarketingPanel {...{ marketing, action, onClose, onDelete }} />
      <MarketingForm {...{ marketing, action, onClose, onSubmit}} />
    </ResourceModal>
  );
}

export default MarketingModal;
